import { type Locale, User, UserSdk } from 'invictus-sdk-typescript'

import { type AppIdType, getDeviceSettings } from '@Utils/user'

export class SdkFactory {
  static getUser(locale: Locale, appId?: AppIdType): UserSdk {
    return new UserSdk(new User(getDeviceSettings({ locale, appId })))
  }
}
